
export const convertToNewColors = (color?: string, isBarsorting?: boolean) => {
    switch (color) {
        case "f4909f":
            return "#F24C68";
        case "cb90f4":
            return "#8662bf";
        case "90f4f4":
            return "#03A0E5";
        case "f7f78f":
            return "#E5AE33";
        case "eeeeee":
            if (isBarsorting) {
                return "#eeeeee";
            }
            return "#B3B3B3";
        case "d0f490":
        default:
            return "#00ABA4";
    }
}